module.exports = __webpack_public_path__ + "static/mother_of_pearl-5f5085f7ab15c89fc9a7f73bacc7839d.svg";